export default "__VITE_ASSET__CNk8WcNH__"